export default "__VITE_ASSET__4APHKTaN__"